import { DataBean } from "../DataBean";

export class BagTagItem extends DataBean {

  public async getBagTagItemCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getBagTagItemCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteBagTagItem(idbagtagitem: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteBagTagItem_Number",
      [idbagtagitem]
    );
  }

  public async getBagTagItemRender(page: number, rows: number, props: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.shared.Report_getBagTagItemRender_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async updateBagTagItem(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.BagTagItem_updateBagTagItem_com.advantage.processflow.bean.BagTagItem",
      [
        {
          "DataBeanProperties": bean,
          "DataBeanName": "com.advantage.processflow.bean.BagTagItem"
        }
      ]
    );
  }
}
